// Third parties
window.moment = require('moment');

// Registration entry
require('./entry/entry');

// Registrant
require('./registrant/registrant');

// Registrant features
require('./registrant-feature/questions');
require('./registrant-feature/access-codes');
require('./registrant-feature/runkeeper');
require('./registrant-feature/personal-information');
require('./registrant-feature/sub-event-validation');
require('./registrant-feature/discount-validation');
require('./registrant-feature/start-groups');
require('./registrant-feature/teams');
require('./registrant-feature/products');
require('./registrant-feature/registration-questions');
require('./registrant-feature/memberships');
require('./registrant-feature/usat');
require('./registrant-feature/usat-batch');
require('./registrant-feature/promo-codes');
require('./registrant-feature/sub-events');
require('./registrant-feature/fundraising-settings');
require('./registrant-feature/runkeeper');

// Registration features
require('./feature/memberships/memberships');
require('./feature/waivers/waivers');
require('./feature/donations/donations');
require('./feature/grassrootz/grassrootz');
require('./feature/shipping/shipping');
require('./feature/scotiabank/scotiabank');
